export default __webpack_public_path__ + "static/media/021-growth.0f89ff3e.svg";